import moment from 'moment'

export default {
  flightParam (VueApp, cabin, leg) {
    // let self = this
    let store = VueApp.$store.state
    let booking = store.booking
    let filters = booking.filters
    let locations = booking.locations

    let date = leg === 'leg1' ? 'date' : 'return'
    let pickup = leg === 'leg1' ? 'pickup' : 'dropoff'
    let dropoff = leg === 'leg1' ? 'dropoff' : 'pickup'
    let params = {
      AdultCount: filters.travellers.adult,
      ChildCount: filters.travellers.children,
      InfantCount: filters.travellers.infants,
      JourneyType: 'OneWay',
      PreferredAirlines: [''],
      CabinClass: cabin,
      Segments: [{
        Origin: locations[`${pickup}Airport`].code,
        Destination: locations[`${dropoff}Airport`].code,
        DepartureDate: moment(filters.departure[date], 'MM/DD/YYYY').format('YYYY-MM-DD') + 'T00:00:00'
      }]
    }

    if (!booking.settings.customFlight && filters.departure.isReturning) {
      params.JourneyType = 'Return'
      params.Segments[0].ReturnDate = moment(filters.departure.return, 'MM/DD/YYYY').format('YYYY-MM-DD') + 'T00:00:00'
    }

    if (store.other.widgetTab === 'flight') {
      let flight = locations.flight
      params.Segments[0].Origin = flight[pickup].code
      params.Segments[0].Destination = flight[dropoff].code
    }

    // if (locations.pickup.country !== locations.dropoff.country) {
    let origin = booking.nearByAirports.international[locations[pickup].title]
    let destination = booking.nearByAirports.international[locations[dropoff].title]
    let airportArchive = [...booking.nearByAirports.pickup, ...booking.nearByAirports.dropoff]
    if (origin) {
      params.Segments[0].Origin = origin

      let airportData = airportArchive.find(x => x.airport.code === origin)
      if (airportData) {
        if (leg === 'leg1') {
          VueApp.$store.commit('booking/setLocationsData', {
            pickupAirport: airportData.airport,
            dropoffAirportReturn: airportData.airport
          })
        } else {
          VueApp.$store.commit('booking/setLocationsData', {dropoffAirportReturn: airportData.airport})
        }
      }
    }
    if (destination) {
      params.Segments[0].Destination = destination

      let airportData = airportArchive.find(x => x.airport.code === destination)
      if (airportData) {
        if (leg === 'leg1') {
          VueApp.$store.commit('booking/setLocationsData', {
            dropoffAirport: airportData.airport,
            pickupAirportReturn: airportData.airport
          })
        } else {
          VueApp.$store.commit('booking/setLocationsData', {pickupAirportReturn: airportData.airport})
        }
      }
    }
    // }
    return params
  },

  buildFlightData (VueApp, r, cabin, leg) {
    let self = this
    let booking = VueApp.$store.state.booking
    let filters = booking.filters
    let airlinesUnique = []
    let flights = []
    let cabinFlights = {}
    let uniqueFlights = {}
    r.FlightDataList.JourneyList[0] = r.FlightDataList.JourneyList[0].sort((a, b) => {
      if (a.Price.TotalDisplayFare < b.Price.TotalDisplayFare) return -1
      if (a.Price.TotalDisplayFare > b.Price.TotalDisplayFare) return 1
      return 0
    })
    r.FlightDataList.JourneyList[0].forEach(data => {
      let price = data.Price
      let flight = []
      let returnFlight = []
      let layover = 0
      let layoverReturn = 0
      let lastArriveTime = ''
      let lastArriveTimeReturn = ''
      let flightInfo = data.FlightDetails.Details[0]
      let flightInfoX = data.FlightDetails.Details

      // Do not include flights with different airport
      if (leg === 'leg1') {
        if (flightInfo[0].Origin.AirportCode !== booking.locations.pickupAirport.code || flightInfo[flightInfo.length - 1].Destination.AirportCode !== booking.locations.dropoffAirport.code) return
        if (flightInfoX.length > 1 && (flightInfoX[1][0].Origin.AirportCode !== booking.locations.pickupAirportReturn.code || flightInfoX[1][flightInfoX[1].length - 1].Destination.AirportCode !== booking.locations.dropoffAirportReturn.code)) return
      }

      flightInfo.forEach((f, i) => {
        let tmpFlightObj = {
          origin: f.Origin,
          destination: f.Destination,
          duration: parseInt(f.Duration),
          airline: {
            code: f.OperatorCode,
            name: f.OperatorName
          },
          flightNo: f.FlightNumber,
          logo: f.OperatorLogo || 'https://prod-opoli-web.s3.us-west-2.amazonaws.com/wordpress-assets/op/home/default-logo.png',
          personalitem: f.Attr && f.Attr.CabinBaggage ? f.Attr.CabinBaggage : 'Non Included'
        }
        if (i > 0) {
          tmpFlightObj.layover = moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').diff(moment(flightInfo[i - 1].Destination.DateTime, 'YYYY-MM-DD HH:mm'), 'minutes')
        }
        flight.push(tmpFlightObj)
        if (lastArriveTime) {
          layover += moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').diff(lastArriveTime, 'minutes')
        }
        lastArriveTime = moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm')
      })

      if (!booking.settings.customFlight && filters.departure.isReturning && data.FlightDetails.Details[1]) {
        data.FlightDetails.Details[1].forEach((f, i) => {
          returnFlight.push({
            origin: f.Origin,
            destination: f.Destination,
            duration: parseInt(f.Duration),
            airline: {
              code: f.OperatorCode,
              name: f.OperatorName
            },
            flightNo: f.FlightNumber,
            logo: f.ReturnOperatorLogo || 'https://prod-opoli-web.s3.us-west-2.amazonaws.com/wordpress-assets/op/home/default-logo.png',
            personalitem: f.Attr && f.Attr.CabinBaggage ? f.Attr.CabinBaggage : 'Non Included'
          })
          if (lastArriveTimeReturn) {
            layoverReturn += moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').diff(lastArriveTimeReturn, 'minutes')
          }
          lastArriveTimeReturn = moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm')
        })
      }

      let TotalDisplayFare = price.PriceBreakup.BasicFare
      if (price.PriceBreakup.Tax) TotalDisplayFare += price.PriceBreakup.Tax
      let totalWithMarkUp = TotalDisplayFare + (TotalDisplayFare * booking.settings.markUpPercent)
      let originalPayment = {
        currency: price.Currency,
        total: parseFloat(TotalDisplayFare.toFixed(2)),
        totalWithMarkUp: parseFloat(totalWithMarkUp.toFixed(2)),
        breakdown: Object.assign({}, price.PassengerBreakup.ADT)
      }
      let payment = {
        currency: price.Currency,
        total: parseFloat(TotalDisplayFare.toFixed(2)),
        totalWithMarkUp: parseFloat(totalWithMarkUp.toFixed(2)),
        breakdown: price.PassengerBreakup.ADT || price.PriceBreakup
      }
      if (price.Currency !== 'USD') {
        payment.currency = 'USD'
        // let currRate = self.currencyStore.list[price.Currency]
        payment.total = self.reconvertCurrency(VueApp, price.PriceBreakup.BasicFare, price.Currency)
        if (price.PriceBreakup.Tax) payment.total += self.reconvertCurrency(VueApp, price.PriceBreakup.Tax, price.Currency)
        payment.total = parseFloat(payment.total.toFixed(2))
        payment.totalWithMarkUp = payment.total + (payment.total * booking.settings.markUpPercent)
        payment.totalWithMarkUp = parseFloat(payment.totalWithMarkUp.toFixed(2))

        if (payment.breakdown) {
          for (const pbKey in payment.breakdown) {
            payment.breakdown[pbKey] = self.reconvertCurrency(VueApp, payment.breakdown[pbKey], price.Currency)
          }
        }

        // let breakdownTotal = 0
        // if (payment.breakdown.BasePrice) {
        //   payment.breakdown.BasePrice = self.reconvertCurrency(VueApp, payment.breakdown.BasePrice, price.Currency)
        //   payment.breakdown.BasePrice = parseFloat(payment.breakdown.BasePrice.toFixed(2))
        //   breakdownTotal += payment.breakdown.BasePrice
        // }
        // if (payment.breakdown.Tax) {
        //   payment.breakdown.Tax = self.reconvertCurrency(VueApp, payment.breakdown.Tax, price.Currency)
        //   payment.breakdown.Tax = parseFloat(payment.breakdown.Tax.toFixed(2))
        //   breakdownTotal += payment.breakdown.Tax
        // }
        // if (payment.breakdown.BasePrice || payment.breakdown.Tax) {
        //   payment.breakdown.TotalPrice = parseFloat(breakdownTotal.toFixed(2))
        // }
      }
      let flightName = flightInfo[0].OperatorName ? flightInfo[0].OperatorName.toLowerCase() : flightInfo[0].OperatorName
      let tmpFlightData = {
        cabin: data.CabinSearchType,
        payment: payment,
        originalPayment: originalPayment,
        isRefundable: data.Attr ? (data.Attr.IsRefundable || false) : false,
        personalItem: flightInfo[0].Attr.Baggage && flightInfo[0].Attr.Baggage !== '0  Piece',
        carryOnBag: flightInfo[0].Attr.CabinBaggage && flightInfo[0].Attr.CabinBaggage !== '',
        hasCarryOn: !!flightInfo[0].Attr.CabinBaggage,
        hasCheckInBag: !!flightInfo[0].Attr.Baggage,
        airlineRemark: data.Attr ? (data.Attr.AirlineRemark || '') : '',
        fareType: data.Attr ? (data.Attr.FareType || '') : '',
        flight: flight,
        returnFlight: returnFlight,
        flightName: flightName,
        token: data.ResultToken,
        available: true,
        layover: {
          leg1: layover,
          leg2: layoverReturn
        }
      }
      flights.push(tmpFlightData)

      // Push flight data to cabin array
      if (!cabinFlights[data.CabinSearchType]) cabinFlights[data.CabinSearchType] = []
      cabinFlights[data.CabinSearchType].push(tmpFlightData)

      // Organize Unique flight + capture non-unique to options
      let flightCodeNo = `${tmpFlightData.flight[0].airline.code}${tmpFlightData.flight[0].flightNo}`
      if (!uniqueFlights[flightCodeNo]) {
        uniqueFlights[flightCodeNo] = tmpFlightData
        uniqueFlights[flightCodeNo].options = []
      }
      uniqueFlights[flightCodeNo].options.push(JSON.parse(JSON.stringify(tmpFlightData)))

      if (airlinesUnique.findIndex(au => au.name === flightName.trim()) === -1) {
        if (flightInfo[0].OperatorName) {
          airlinesUnique.push({
            name: flightName.trim(),
            price: payment.totalWithMarkUp,
            logo: flightInfo[0].OperatorLogo
          })
        }
      }
    })

    let tmpCabin = typeof cabin !== 'object' ? cabin : 'API2'
    let tmpFirstFlight = {leg: leg, fields: {}}
    if (!flights.length) tmpFirstFlight.fields[tmpCabin] = 0
    tmpFirstFlight.fields[tmpCabin] = flights[0].payment.totalWithMarkUp
    VueApp.$store.commit('booking/setFirstFlightPrice', tmpFirstFlight)

    airlinesUnique.sort()
    return {
      flights: flights,
      airlinesUnique: airlinesUnique,
      cabinFlights: cabinFlights,
      uniqueFlights: uniqueFlights
    }
  },

  reconvertCurrency (VueApp, x, code) {
    let currencyStore = VueApp.$store.state.other.currency
    let currRate = currencyStore.list[code]
    x = parseFloat(x.toFixed(2))
    x = parseFloat((x / currRate).toFixed(2))
    return x
  },

  resetAirlineData (VueApp, cabin, leg) {
    let self = this
    if (typeof cabin === 'object') {
      cabin.forEach(c => {
        self.resetAirlineInit(VueApp, c, leg)
      })
      self.resetAirlineInit(VueApp, 'API2', leg)
      return
    }
    self.resetAirlineInit(VueApp, cabin, leg)
  },
  resetAirlineInit (VueApp, cabin, leg) {
    let tmp = {}
    tmp[cabin] = []
    let data = {leg: leg, fields: tmp}
    VueApp.$store.commit('booking/setAirlinesLegData', data)
    VueApp.$store.commit('booking/setAirlinesFilteredData', data)
    VueApp.$store.commit('booking/setAirlinesUniqueLegData', data)
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/booking.js